<template>
  <div>
    <v-app-bar app>
      <v-toolbar-title>Relief Spa and Massage Manage</v-toolbar-title>
      <v-spacer />
      <v-btn
        icon
        to="/customer/profile"
      >
        <v-icon small>
          fas fa-user
        </v-icon>
      </v-btn>
      <v-btn
        icon
        to="/customer/products"
      >
        <v-icon small>
          fas fa-shopping-cart
        </v-icon>
      </v-btn>
      <v-btn
        icon
        @click="logout"
      >
        <v-icon small>
          fas fa-sign-out-alt
        </v-icon>
      </v-btn>
    </v-app-bar>
    <v-content>
      <router-view />
    </v-content>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { UNSET_USER } from '@/store/mutation_types';

export default {
  name: 'TheCustomerLayout',
  data() {
    return {
      loading: true,
    };
  },
  methods: {
    ...mapActions([UNSET_USER]),
    logout() {
      this.UNSET_USER();
      this.$router.push('/');
    },
  },
};
</script>
